import React from 'react';
import { Routes, Route, Navigate, Router } from 'react-router-dom';
import { LoginCallback, SecureRoute } from '@okta/okta-react';
import { SchoolPrepChecklist } from '../pages/SchoolPrepChecklist';
import LearningMaterial from '../pages/LearningMaterial';
import { Community } from '../pages/Community';
import { Contact } from '../pages/Contact';
import RequiredSecureAuth from './SecureRoute';
import MainPageLayout from '../pages/MainPageLayout';
import NotFound from '../pages/NotFoundLayout';

import MainChecklistFormsDocs from '../pages/checklist/MainChecklistFormsDocs';
import SchoolDocuments from '../pages/checklist/SchoolDocuments';
import ConsentProcess from '../pages/checklist/ConsentProcess';

import MainChecklistLearningCoachLife from '../pages/checklist/MainChecklistLearningCoachLife';
import LearningCoachOverviewDetails from '../pages/checklist/LearningCoachOverviewDetails';
import LearningCoachRoleDetails from '../pages/checklist/LearningCoachRoleDetails';

import MainChecklistEmailSetup from '../pages/checklist/MainChecklistEmailSetup';
import EmailOptions from '../pages/checklist/EmailOptions';
import EmailBasics from '../pages/checklist/EmailBasics';

import MainChecklistOnlineSchool from '../pages/checklist/MainChecklistOnlineSchool';
import SchoolStartFAQ from '../pages/checklist/SchoolStartFAQ';
import NavigatingOnlineSchool from '../pages/checklist/NavigatingOnlineSchool';
import SampleLessons from '../pages/checklist/SampleLessons';
import { K12ZoneContent } from '../pages/K12ZoneContent';
import { LearningCoachCommunity } from '../pages/LearningCoachCommunity';
import CanvasLanding from '../pages/CanvasLanding';

const AppRoutes = () => {
const token = sessionStorage.getItem('authToken') || '';
// console.log(token);

return (
<Routes>
                
    {/* PRIVATE Routes */}
    <Route path='/' element={<RequiredSecureAuth />}>
    
        <Route path='/' element={<MainPageLayout />} /> 
        <Route path="/school-prep-checklist" element={<SchoolPrepChecklist />} />
        <Route path="/learning-materials" element={<LearningMaterial />} />
        <Route path="/community" element={<Community />} />
        <Route path="/community/learning-coach-community" element={<LearningCoachCommunity />} />
        <Route path="/community/k12-zone" element={<K12ZoneContent />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/k12-checklist-category/forms-and-documents/" element={<MainChecklistFormsDocs />} />
        <Route path="/k12-checklist/school-documents/" element={<SchoolDocuments />} />
        <Route path="/k12-checklist/consent-process/" element={<ConsentProcess />} />

        <Route path="/k12-checklist-category/learning-coach-life/" element={<MainChecklistLearningCoachLife />} />
        <Route path="/k12-checklist/what-is-a-learning-coach/" element={<LearningCoachOverviewDetails />} />
        <Route path="/k12-checklist/what-does-a-learning-coach-do/" element={<LearningCoachRoleDetails />} />

        <Route path="/k12-checklist-category/online-school/" element={<MainChecklistOnlineSchool />} />
        <Route path="/k12-checklist/school-start-faqs/" element={<SchoolStartFAQ />} />
        <Route path="/k12-checklist/navigating-the-online-school/" element={<NavigatingOnlineSchool />} />
        <Route path="/k12-checklist/sample-lessons/" element={<SampleLessons />} />

        <Route path="/k12-checklist-category/email-setup/" element={<MainChecklistEmailSetup />} />
        <Route path="/k12-checklist/email-basics/" element={<EmailBasics />} />
        <Route path="/k12-checklist/email-options/" element={<EmailOptions />} />
        <Route path="/milestone-1" element={<CanvasLanding />} />
    </Route>
    {/* PUBLIC Routes */}
    <Route path="/login/callback" element={<LoginCallback />} />
    {/* Catch-All Route */}
    <Route path="*" element={<NotFound />} />
</Routes>
            
);
};

export default AppRoutes;